import { getPublicKeyApi, getPublicInfoApi, alertApi } from "../ENV";
import { fetchApi } from "./FetchAPI";

export async function fetchPublicKey(privateKey) {
  const headers = {
    Accept: "application/json",
    "Content-type": "application/json"
  };
  const params = { private_key: privateKey };
  return await fetchApi(getPublicKeyApi, "GET", {}, headers, params);
}

export async function fetchPublicInfo(publicKey) {
  const headers = {
    Accept: "application/json",
    "Content-type": "application/json"
  };
  const params = { public_key: publicKey };
  return await fetchApi(getPublicInfoApi, "GET", {}, headers, params);
}

export async function postAlert(ipAddress, cardId, latitude = null, longitude = null) {
  const headers = {
    Accept: "application/json",
    "Content-type": "application/json"
  };
  const payload = { ip_address: ipAddress, card_id: cardId };
  if (typeof latitude === 'number' && typeof longitude === 'number') {
    payload.latitude = latitude;
    payload.longitude = longitude;
  }
  const body = JSON.stringify(payload);
  return await fetchApi(alertApi, "POST", body, headers, {});
}


